import React from "react";
import { Tour } from "../EstadisticasHotel";

interface Props {
    tours: Tour[];
    isOpen: boolean;
    onClose: () => void;
    moneda: string;
}

export const ToursIngresosList: React.FC<Props> = ({
    tours,
    isOpen,
    onClose,
    moneda,
}) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-11/12 p-6 bg-white rounded-lg shadow-lg md:w-8/12 lg:w-6/12">
                <button
                    onClick={onClose}
                    className="absolute text-gray-600 top-3 right-3 hover:text-gray-800"
                    aria-label="Cerrar modal">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="w-6 h-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>

                <h2 className="mb-4 text-xl font-semibold text-center">
                    Ingresos de Tours
                </h2>

                {tours.length === 0 ? (
                    <p className="py-4 text-center text-gray-600">
                        No hay ingresos de tours en este mes.
                    </p>
                ) : (
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                        {tours.map((tour) => (
                            <div
                                key={tour.id}
                                className="flex flex-col items-center p-3 border rounded">
                                <img
                                    src={`${process.env.REACT_APP_PROXY}/hoteles_tours/getImage/${tour.banner}`}
                                    alt={tour.nombre}
                                    className="object-cover w-32 h-16 rounded"
                                />
                                <div>
                                    <p className="font-medium">{tour.nombre}</p>

                                    <p className="text-sm text-gray-600">
                                        Ingresos:{" "}
                                        <span className="font-bold">
                                            {tour.ingreso_total} {moneda}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};
